import {h, Component} from 'preact';
export default class NavLeft extends Component {
    render() {
        return (
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 42">
                <path fill={this.props.color} d="M13.47,38a1.49,1.49,0,0,0,1.22-2.36L4.37,21.49,14.69,7.39a1.5,1.5,0,1,0-2.44-1.73l-10.94,15a1.5,1.5,0,0,0,0,1.74l10.94,15A1.49,1.49,0,0,0,13.47,38Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/NavLeft.js